module.exports = __webpack_public_path__ + "static/img/goods_profile_header_info_coupon_bg.05c9f670.png";